import { useState, useEffect } from 'react';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { MDBDataTable } from "mdbreact";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { Modal, DatePicker } from "antd";
import axios from "axios";
import dayjs from 'dayjs';

import Loading from "../Loading";
import { currency } from '../../../../dynamicController';

import { useTranslation } from "react-i18next";

const { RangePicker } = DatePicker;

const mySwal = withReactContent(Swal);

const GeneralVoucherCodeCard = ({ token, id, role, country }) => {

    const { t } = useTranslation();

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [code, setCode] = useState("");
    const [start_date, setStartDate] = useState("");
    const [end_date, setEndDate] = useState("");
    const [new_user, setNewUser] = useState(false);
    const [redeem_per_user, setRedeemPerUser] = useState(1);
    const [pay_and_use, setPayAndUse] = useState(false);
    const [pay_and_use_amount, setPayAndUseAmount] = useState(1);
    const [voucher_setting, setVoucherSetting] = useState([
        {
            type: "Voucher Code",
            voucher_eligible: true,
            voucher_amount: 3,
            voucher_type: "Flat",
            voucher_expiry: true,
            voucher_duration: 30,
            voucher_title: "VOUCHER CODE REWARDS",
            voucher_description: "Thank you for redeem the voucher code!",
            voucher_washer_use: true,
            voucher_dryer_use: true,
            voucher_package_use: false,
            voucher_vending_use: false,
            voucher_detergent_use: false,
            voucher_carwash_use: false,
            recurring: true,
            recurring_number: 1,
            recurring_period: 30
        }
    ]);

    useEffect(() => {
        if (id && role) {
            setLoading(true)
            axios
                .post("/api/admin/setting/getGeneralVoucherCode", { id, role }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    setData(res.data.data);
                    setLoading(false);
                })
                .catch(err => {
                    setLoading(false);
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                });
        }
    }, [id, role])

    const handleDate = dates => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    };

    const openModal = () => {
        setCode("");
        setStartDate("");
        setEndDate("");
        setNewUser(false);
        setRedeemPerUser(1);
        setPayAndUse(false);
        setPayAndUseAmount(1);
        setVoucherSetting([
            {
                type: "Voucher Code",
                voucher_eligible: true,
                voucher_amount: 3,
                voucher_type: "Flat",
                voucher_expiry: true,
                voucher_duration: 30,
                voucher_title: "VOUCHER CODE REWARDS",
                voucher_description: "Thank you for redeem the voucher code!",
                voucher_washer_use: true,
                voucher_dryer_use: true,
                voucher_package_use: false,
                voucher_vending_use: false,
                voucher_detergent_use: false,
                voucher_carwash_use: false,
                recurring: true,
                recurring_number: 1,
                recurring_period: 30
            }
        ])
        setShowModal(true);
    }

    const hideModal = () => {
        setCode("");
        setStartDate("");
        setEndDate("");
        setNewUser(false);
        setRedeemPerUser(1);
        setPayAndUse(false);
        setPayAndUseAmount(1);
        setVoucherSetting([
            {
                type: "Voucher Code",
                voucher_eligible: true,
                voucher_amount: 3,
                voucher_type: "Flat",
                voucher_expiry: true,
                voucher_duration: 30,
                voucher_title: "VOUCHER CODE REWARDS",
                voucher_description: "Thank you for redeem the voucher code!",
                voucher_washer_use: true,
                voucher_dryer_use: true,
                voucher_package_use: false,
                voucher_vending_use: false,
                voucher_detergent_use: false,
                voucher_carwash_use: false,
                recurring: true,
                recurring_number: 1,
                recurring_period: 30
            }
        ])
        setShowModal(false);
    }

    const removeFields = (index) => {
        let list = [...voucher_setting]
        list.splice(index, 1)
        setVoucherSetting(list)
    }

    const addFields = () => {
        setVoucherSetting(
            [
                ...voucher_setting,
                {
                    type: "Voucher Code",
                    voucher_eligible: true,
                    voucher_amount: 3,
                    voucher_type: "Flat",
                    voucher_expiry: true,
                    voucher_duration: 30,
                    voucher_title: "VOUCHER CODE REWARDS",
                    voucher_description: "Thank you for redeem the voucher code!",
                    voucher_washer_use: true,
                    voucher_dryer_use: true,
                    voucher_package_use: false,
                    voucher_vending_use: false,
                    voucher_detergent_use: false,
                    voucher_carwash_use: false,
                    recurring: true,
                    recurring_number: 1,
                    recurring_period: 30
                }
            ]
        )
    }

    const addVoucherCode = (e) => {
        e.preventDefault();

        if (!code) {
            return mySwal.fire(t("Error"), t("Please enter the voucher code"), "error");
        } else if (!start_date || !end_date) {
            return mySwal.fire(t("Error"), t("Please select the start date and end date"), "error");
        } else if (new Date(start_date) > new Date(end_date)) {
            return mySwal.fire(t("Error"), t("Start date must before end date"), "error");
        } else if (redeem_per_user < 1) {
            return mySwal.fire(t("Error"), t("Redeem per user must at least 1"), "error");
        } else if (pay_and_use_amount < 0) {
            return mySwal.fire(t("Error"), t("Minimum transaction amount to use code cannot be negative"), "error");
        } else {
            setLoading(true);

            const sendThis = {
                id,
                role,
                code,
                start_date,
                end_date,
                new_user,
                redeem_per_user,
                pay_and_use,
                pay_and_use_amount,
                voucher_setting,
            }

            axios
                .post("/api/admin/setting/createGeneralVoucherCode", sendThis, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {

                    axios
                        .post("/api/admin/setting/getGeneralVoucherCode", { id, role }, { headers: { "Content-Type": "application/json", "auth-token": token } })
                        .then(res => {
                            setData(res.data.data);
                            setLoading(false);
                            setShowModal(false);
                            mySwal.fire(t("Success"), t("Successfully create the voucher code"), "success");
                        })
                        .catch(err => {
                            setLoading(false);
                            mySwal.fire(t("Error"), t(err.response.data.error), "error");
                        })
                })
                .catch(err => {
                    setLoading(false);
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                });
        }
    }

    let tableData = {
        columns: [
            {
                label: t("Created Date"),
                field: "createdAt",
                sort: "asc"
            },
            {
                label: t("Voucher Code"),
                field: "code",
                sort: "asc"
            },
            {
                label: t("Start Date"),
                field: "start_date",
                sort: "asc"
            },
            {
                label: t("End Date"),
                field: "end_date",
                sort: "asc"
            },
            {
                label: t("Pay And Get Voucher"),
                field: "pay_and_use",
                sort: "asc"
            },
            {
                label: `${t("Minimum Transaction Amount To Use Voucher")} (${currency(country)})`,
                field: "pay_and_use_amount",
                sort: "asc"
            },
            {
                label: t("Redeem Per User"),
                field: "redeem_per_user",
                sort: "asc"
            },
            {
                label: t("New User Only"),
                field: "new_user",
                sort: "asc"
            },
        ],
        rows: data
    };

    return (
        <div>
            <div className="card">
                <div className="card-header d-flex justify-content-between">
                    <h5 className="card-title">{t("General Voucher Code")}</h5>

                    <button className="btn btn-primary" type="button" onClick={e => openModal()}>
                        {t("Add Voucher Code")}
                    </button>
                </div>

                <div className="card-body">
                    <div>
                        {
                            loading
                                ? <Loading />
                                : <MDBDataTable data={tableData} noBottomColumns striped hover responsive bordered />
                        }
                    </div>
                </div>
            </div>

            <Modal
                title={t("Add Voucher Code")}
                open={showModal}
                footer={null}
                onCancel={e => hideModal()}
                centered
            >
                <div>
                    <form onSubmit={addVoucherCode}>
                        <p><b>{t("Voucher Code Settings")}</b></p>
                        <div style={{ margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                            <div className="form-group">
                                <label>
                                    <input type="checkbox" id="new_user" name="new_user" checked={new_user} onChange={e => setNewUser(!new_user)} />
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>
                                                {t("If ticked, the voucher code only can redeem in register page")}
                                            </Tooltip>
                                        }
                                    >
                                        <span>{t("New User Only")}</span>
                                    </OverlayTrigger>
                                </label>
                            </div>

                            <div className="form-group">
                                <label>
                                    <input type="checkbox" id="pay_and_use" name="pay_and_use" checked={pay_and_use} onChange={e => setPayAndUse(!pay_and_use)} />
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>
                                                {t("If ticked, the user only can use the voucher after make a transaction")}
                                            </Tooltip>
                                        }
                                    >
                                        <span>{t("Pay And Get Voucher")}</span>
                                    </OverlayTrigger>
                                </label>
                            </div>
                        </div>

                        <div className="form-group text-left">
                            <label htmlFor="code">{t("Voucher Code")}</label>
                            <input type="text" id="code" name="code" value={code} className="form-control browser-default" onChange={e => setCode(e.target.value.toUpperCase())} required />
                        </div>

                        <div className="form-group text-left">
                            <label htmlFor="date">{t("Select Period")}: </label>
                            <RangePicker
                                id="date"
                                name="date"
                                placeholder={[t("Start date"), t("End date")]}
                                onChange={handleDate}
                                style={{ width: '100%' }}
                                value={start_date && end_date ? [dayjs(start_date), dayjs(end_date)] : []}
                            />
                        </div>

                        <div className="form-group text-left">
                            <label htmlFor="redeem_per_user">{t("Redeem per user")} <small>({t("How many times the voucher code can be used for each user")})</small> : </label>
                            <input type="number" className="form-control browser-default" id="redeem_per_user" name="redeem_per_user" value={redeem_per_user} onChange={e => setRedeemPerUser(e.target.value)} min="1" step="1" required />
                        </div>

                        {
                            pay_and_use ? (
                                <div className="form-group">
                                    <label htmlFor="pay_and_use_amount">{t("Minimum Transaction Amount To Use Voucher")}:({currency(country)})</label>
                                    <input type="number" id="pay_and_use_amount" name="pay_and_use_amount" value={pay_and_use_amount} onChange={e => setPayAndUseAmount(e.target.value)} className="form-control browser-default" required step="0.01" />
                                </div>
                            ) : null
                        }

                        <p className="pt-3"><b>{t("Voucher Settings")}</b></p>

                        {
                            voucher_setting.map((setting, i) => {
                                return (
                                    <div key={i}>
                                        <p>{t("Voucher")} {i + 1}</p>
                                        <div style={{ margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_expiry" name="voucher_expiry" checked={setting.voucher_expiry} onChange={e => {
                                                        let list = [...voucher_setting]
                                                        list[i].voucher_expiry = !list[i].voucher_expiry
                                                        setVoucherSetting(list)
                                                    }} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher will have expired date")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Expiry")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>

                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_package_use" name="voucher_package_use" checked={setting.voucher_package_use} onChange={e => {
                                                        let list = [...voucher_setting]
                                                        list[i].voucher_package_use = !list[i].voucher_package_use
                                                        setVoucherSetting(list)
                                                    }} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher can apply to Drop n Go transaction")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Package Use")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>
                                        </div>

                                        <div style={{ margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_washer_use" name="voucher_washer_use" checked={setting.voucher_washer_use} onChange={e => {
                                                        let list = [...voucher_setting]
                                                        list[i].voucher_washer_use = !list[i].voucher_washer_use
                                                        setVoucherSetting(list)
                                                    }} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher can apply to washer machine transaction")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Washer Use")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>

                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_dryer_use" name="voucher_dryer_use" checked={setting.voucher_dryer_use} onChange={e => {
                                                        let list = [...voucher_setting]
                                                        list[i].voucher_dryer_use = !list[i].voucher_dryer_use
                                                        setVoucherSetting(list)
                                                    }} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher can apply to dryer machine transaction")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Dryer Use")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>
                                        </div>

                                        <div style={{ margin: "auto", display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_vending_use" name="voucher_vending_use" checked={setting.voucher_vending_use} onChange={e => {
                                                        let list = [...voucher_setting]
                                                        list[i].voucher_vending_use = !list[i].voucher_vending_use
                                                        setVoucherSetting(list)
                                                    }} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher can apply to vending machine transaction")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Vending Use")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>

                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_detergent_use" name="voucher_detergent_use" checked={setting.voucher_detergent_use} onChange={e => {
                                                        let list = [...voucher_setting]
                                                        list[i].voucher_detergent_use = !list[i].voucher_detergent_use
                                                        setVoucherSetting(list)
                                                    }} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher can apply to detergent vending machine transaction")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Detergent Vending Use")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>

                                            <div className="form-group">
                                                <label>
                                                    <input type="checkbox" id="voucher_carwash_use" name="voucher_carwash_use" checked={setting.voucher_carwash_use} onChange={e => {
                                                        let list = [...voucher_setting]
                                                        list[i].voucher_carwash_use = !list[i].voucher_carwash_use
                                                        setVoucherSetting(list)
                                                    }} />
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip>
                                                                {t("If ticked, the voucher can apply to car wash transaction")}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{t("Car Wash Use")}</span>
                                                    </OverlayTrigger>
                                                </label>
                                            </div>
                                        </div>

                                        {
                                            setting.voucher_expiry ? (
                                                <div className="form-group">
                                                    <label htmlFor="voucher_duration">{t("Voucher Lifespan")} : <small> ({t("days")})</small></label>
                                                    <input type="number" id="voucher_duration" name="voucher_duration" value={setting.voucher_duration} required min="1" step="1" onChange={e => {
                                                        let list = [...voucher_setting]
                                                        list[i].voucher_duration = e.target.value
                                                        setVoucherSetting(list)
                                                    }} />
                                                </div>
                                            ) : null
                                        }

                                        <div className="form-group">
                                            <label htmlFor="voucher_title">{t("Voucher Title")} : </label>
                                            <input type="text" id="voucher_title" name="voucher_title" placeholder={t("Voucher Title")} value={setting.voucher_title} required onChange={e => {
                                                let list = [...voucher_setting]
                                                list[i].voucher_title = e.target.value
                                                setVoucherSetting(list)
                                            }} />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="voucher_description">{t("Voucher Description")} : </label>
                                            <input type="text" id="voucher_description" name="voucher_description" placeholder={t("Voucher Description")} value={setting.voucher_description} required onChange={e => {
                                                let list = [...voucher_setting]
                                                list[i].voucher_description = e.target.value
                                                setVoucherSetting(list)
                                            }} />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="voucher_type">{t("Discount Type")} : </label>
                                            <select className="browser-default form-select" id="voucher_type" name="voucher_type" value={setting.voucher_type} required onChange={e => {
                                                let list = [...voucher_setting]
                                                list[i].voucher_type = e.target.value
                                                setVoucherSetting(list)
                                            }}>
                                                <option value="" disabled>{t("Select a discount type")}</option>
                                                <option value="Flat">{t("Flat")} (- {currency(country)})</option>
                                                <option value="Rate">{t("Rate")} (- %)</option>
                                            </select>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="voucher_amount">{t("Voucher Amount")} : <small>{setting.voucher_type === "Flat" ? `(${currency(country)})` : "(%)"}</small></label>
                                            <input type="number" id="voucher_amount" name="voucher_amount" value={setting.voucher_amount} required min="1" step="0.01" onChange={e => {
                                                let list = [...voucher_setting]
                                                list[i].voucher_amount = e.target.value
                                                setVoucherSetting(list)
                                            }} />
                                        </div>

                                        {
                                            i < voucher_setting.length - 1 ? (
                                                <div className="form-group">
                                                    <label htmlFor="recurring_period">{t("Period for giving next voucher")} : <small> ({t("days")})</small></label>
                                                    <input type="number" id="recurring_period" name="recurring_period" value={setting.recurring_period} min="1" step="1" required onChange={e => {
                                                        let list = [...voucher_setting]
                                                        list[i].recurring_period = e.target.value
                                                        setVoucherSetting(list)
                                                    }} />
                                                </div>
                                            ) : null
                                        }

                                        <div className="form-group text-center">
                                            <button type="button" className="btn btn-secondary" onClick={(e) => removeFields(i)}>
                                                {t("Remove")}
                                            </button>
                                        </div>
                                    </div>
                                )
                            })
                        }

                        <div className="form-group pt-3">
                            <button type="button" className="btn btn-dark" onClick={(e) => addFields()}>
                                {t("Add Voucher")}
                            </button>
                        </div>

                        <div className="text-center pt-3">
                            {loading ? (
                                <div className="text-center">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            ) : <input type="submit" value={t("Add Voucher Code")} className="btn btn-primary mx-2" />}
                            <button type="button" className="btn btn-secondary" onClick={e => hideModal()}>
                                {t("Close")}
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>
        </div>
    );
};

export default GeneralVoucherCodeCard;